module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/qfgJfsmTYXFdtygNNSiYN-521fe47e1a64a53966cb3f01771eecff.jpg";